import { useOpenStateStore } from '../stores/OpenStateStore';

export function useTailorHalfOpen() {
  const halfOpen = useOpenStateStore((state) => state.halfOpen);
  const setHalfOpen = useOpenStateStore((state) => state.setHalfOpen);

  return { halfOpen, setHalfOpen };
}
